import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet } from "@ionic/vue";
import BaseComponent from "@/components/Modals/BaseComponent.vue";
import Toast from "primevue/toast";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Toast)),
      _createVNode(BaseComponent),
      _createVNode(_unref(IonRouterOutlet), { animated: "false" })
    ]),
    _: 1
  }))
}
}

})